/*
  Adds Element#closest to IE9+
  https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
*/
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector ||
    Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function(s) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    var el = this;

    do {
      if (el.matches(s)) {
        return el;
      }
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}

// Prevent editing form input values when aria-readonly is set to "true"
// This allows us to have inputs that are read-only for user input, but still submit form values.
// For use with the submit-form stimulus controller
document.addEventListener("keydown", (e) => {
  const input = e.target;

  if (input.getAttribute("aria-readonly") === "true") {
    // Allow tab navigation (9) but block everything else
    if (e.keyCode !== 9) {
      e.preventDefault();
    }
  }
});

document.addEventListener("beforeinput", (e) => {
  const input = e.target;
  // Blocks pasting and mobile keyboard typing
  if (input.getAttribute("aria-readonly") === "true") {
    e.preventDefault();
  }
});
